<template>
  <div class="prepareLessons">
    <div class="clearfix top">
      <div class="fl">
        <el-form ref="form" :model="form" :inline="true" size="mini">
          <el-form-item label="题目所属">
            <el-select v-model="form.resource" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="平台" value="1"></el-option>
              <el-option label="校区" value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="题目名称">
            <el-input v-model="keyword" prefix-icon="el-icon-search" placeholder="请输入题目名称或编号" size="mini" clearable
              @keyup.enter.native="search"></el-input>
          </el-form-item>
          <el-button type="primary" @click="search" icon="el-icon-search" size="mini">查询</el-button>
        </el-form>
      </div>

      <div class="fr" v-if="$store.state.user.identity === 2 ? false : true" @click="myNew" style="cursor: pointer;">
        <span style="float:right; font-size:15px;margin-left:5px;font-weight:bold;line-height: 20px;">我创建的题目</span>

        <svg style="float:right;" t="1658478298023" class="icon" viewBox="0 0 1024 1024" version="1.1"
          xmlns="http://www.w3.org/2000/svg" p-id="20933" width="20" height="20">
          <path
            d="M786.944 921.6l-188.416-97.28 21.504-37.376 189.44 95.232zM822.784 818.688L632.32 727.04l93.184-162.304 195.072 81.92z"
            fill="#AD8114" p-id="20934"></path>
          <path
            d="M920.576 646.656l-195.072-81.92-31.744-21.504 194.56 81.408zM809.472 882.176l-189.44-95.232-65.024-40.448 187.904 93.696zM507.904 774.144l-4.096 108.544-1.024 30.208 184.32 103.424 1.024-31.744 6.144-114.176z"
            fill="#8E6710" p-id="20935"></path>
          <path d="M694.272 870.4l-186.368-96.256L686.592 465.92l195.072 77.312z" fill="#AD8114" p-id="20936"></path>
          <path
            d="M881.664 543.232l106.496 74.24-182.272 321.024-92.672 60.928-26.112 16.896 1.536-31.744 5.632-114.176 187.392-327.168z m-92.16 254.976l33.28 20.48 97.792-172.032-32.256-22.016-98.816 173.568m-2.56 123.392l22.528-39.424-66.56-41.984-23.04 39.936 67.072 41.472"
            fill="#FFCA28" p-id="20937"></path>
          <path d="M612.352 845.312l-183.808-95.744 181.76-317.952 193.024 76.8z" fill="#1474AF" p-id="20938"></path>
          <path
            d="M803.328 508.416l-193.536-76.288c0-4.096 1.024-27.648 2.048-60.416s3.072-75.264 4.608-117.248c1.536-41.984 3.072-83.968 4.096-115.2 1.024-31.232 1.536-52.224 1.536-52.224l198.144 57.344c0.512 0-0.512 22.016-2.048 55.296-1.536 33.28-3.584 77.312-5.632 121.856-2.048 44.544-4.096 89.088-6.144 123.392-1.536 34.304-2.56 58.88-3.072 63.488"
            fill="#176991" p-id="20939"></path>
          <path d="M507.392 747.008l-181.248-92.672 1.024-62.976 182.272 88.576z" fill="#B2B2B2" p-id="20940"></path>
          <path d="M568.32 670.72l-2.56 66.048-58.368 10.24 2.048-67.072z" fill="#FFFFFF" p-id="20941"></path>
          <path
            d="M509.44 679.936l-182.272-88.576 56.32-8.192L568.32 670.72zM519.68 565.248l-184.32-82.432 92.16-142.848 188.928 73.216z"
            fill="#999999" p-id="20942"></path>
          <path d="M516.608 657.92l-182.784-87.552 1.536-87.552 184.32 82.432z" fill="#A5A5A5" p-id="20943"></path>
          <path d="M616.448 413.184L427.52 339.968l2.56-83.456 189.44 68.608z" fill="#828282" p-id="20944"></path>
          <path d="M283.648 906.24l-172.544-103.424 317.44-53.248 183.808 95.744z" fill="#177ECC" p-id="20945"></path>
          <path d="M421.376 476.16L240.128 397.312l2.56-172.544 183.296 68.608z" fill="#B2B2B2" p-id="20946"></path>
          <path d="M425.984 293.376L242.688 224.768l231.424-22.016 192 65.024z" fill="#D1D1D1" p-id="20947"></path>
          <path
            d="M226.304 114.176L885.76 60.416l-22.528 455.168-226.304 399.872L215.04 997.888l11.264-883.712z m577.024 394.24c0-4.608 1.536-29.184 3.072-63.488 1.536-34.816 4.096-79.36 6.144-123.392 2.048-44.544 4.096-88.576 5.632-121.856 1.536-33.28 2.56-55.296 2.048-55.296L295.424 193.024 283.648 906.24l329.216-60.928 190.464-336.896"
            fill="#1E88E5" p-id="20948"></path>
          <path
            d="M666.112 267.776l-6.144 157.696-96.256 150.528-2.56 74.752-44.544 7.168 3.072-92.672 96.768-152.064 3.072-88.064-147.968 16.896-3.584 128-46.592 6.144 4.608-182.784z"
            fill="#FFFFFF" p-id="20949"></path>
          <path d="M226.304 114.176L48.128 54.272l636.416-46.08L885.76 60.416z" fill="#80CBE8" p-id="20950"></path>
          <path d="M214.528 996.864l-168.96-109.056 2.56-833.536 178.176 59.904z" fill="#4FA9E0" p-id="20951"></path>
        </svg>
      </div>
      <div class="fr" v-if="$store.state.user.identity === 2 ? false : true" @click="stuRecord"
        style="margin-right:15px;cursor: pointer;">
        <span style="float:right; font-size:15px;margin-left:5px;font-weight:bold;line-height: 20px;">刷题记录</span>
        <svg style="float:right;" t="1693448012448" class="icon" viewBox="0 0 1024 1024" version="1.1"
          xmlns="http://www.w3.org/2000/svg" p-id="4073" width="20" height="20">
          <path
            d="M420.79573333 969.65973333c-44.2368 0-80.2816-36.0448-80.2816-80.2816V320.85333333c0-44.2368 36.0448-80.2816 80.2816-80.2816h423.79946667c44.2368 0 80.2816 36.0448 80.2816 80.2816v567.97866667c0 44.2368-36.0448 80.2816-80.2816 80.2816H420.79573333z"
            fill="#27C18F" p-id="4074"></path>
          <path
            d="M844.5952 265.69386667c30.03733333 0 54.61333333 24.576 54.61333333 54.61333333V888.832c0 30.03733333-24.576 54.61333333-54.61333333 54.61333333H420.79573333c-30.03733333 0-54.61333333-24.576-54.61333333-54.61333333V320.85333333c0-30.03733333 24.576-54.61333333 54.61333333-54.61333333h423.79946667m0-51.33653333H420.79573333c-58.43626667 0-105.94986667 47.5136-105.94986666 105.94986666v567.97866667c0 58.43626667 47.5136 105.94986667 105.94986666 105.94986667h423.79946667c58.43626667 0 105.94986667-47.5136 105.94986667-105.94986667V320.85333333c0-58.43626667-48.05973333-105.94986667-105.94986667-105.94986666z"
            fill="#333333" p-id="4075"></path>
          <path
            d="M420.79573333 864.256c-44.2368 0-80.2816-36.0448-80.2816-80.2816V218.7264c0-44.2368 36.0448-80.2816 80.2816-80.2816h423.79946667c44.2368 0 80.2816 36.0448 80.2816 80.2816v564.70186667c0 44.2368-36.0448 80.2816-80.2816 80.2816H420.79573333z"
            fill="#FFBA40" p-id="4076"></path>
          <path
            d="M844.5952 164.11306667c30.03733333 0 54.61333333 24.576 54.61333333 54.61333333v564.70186667c0 30.03733333-24.576 54.61333333-54.61333333 54.61333333H420.79573333c-30.03733333 0-54.61333333-24.576-54.61333333-54.61333333V218.7264c0-30.03733333 24.576-54.61333333 54.61333333-54.61333333h423.79946667m0-51.33653334H420.79573333c-58.43626667 0-105.94986667 47.5136-105.94986666 105.94986667v564.70186667c0 58.43626667 47.5136 105.94986667 105.94986666 105.94986666h423.79946667c58.43626667 0 105.94986667-47.5136 105.94986667-105.94986666V218.7264c0-58.43626667-48.05973333-105.94986667-105.94986667-105.94986667z"
            fill="#333333" p-id="4077"></path>
          <path
            d="M755.57546667 240.57173333c-58.43626667 0-105.94986667-47.5136-105.94986667-105.94986666s47.5136-105.94986667 105.94986667-105.94986667S861.52533333 76.1856 861.52533333 134.62186667c0 14.19946667-11.4688 25.66826667-25.66826666 25.66826666s-25.66826667-11.4688-25.66826667-25.66826666c0-30.03733333-24.576-54.61333333-54.61333333-54.61333334s-54.61333333 24.576-54.61333334 54.61333334 24.576 54.61333333 54.61333334 54.61333333c14.19946667 0 25.66826667 11.4688 25.66826666 25.66826667s-11.4688 25.66826667-25.66826666 25.66826666z"
            fill="#333333" p-id="4078"></path>
          <path
            d="M629.9648 240.57173333c-58.43626667 0-105.94986667-47.5136-105.94986667-105.94986666s47.5136-105.94986667 105.94986667-105.94986667S735.91466667 76.73173333 735.91466667 134.62186667c0 14.19946667-11.4688 25.66826667-25.66826667 25.66826666s-25.66826667-11.4688-25.66826667-25.66826666c0-30.03733333-24.576-54.61333333-54.61333333-54.61333334s-54.61333333 24.576-54.61333333 54.61333334 24.576 54.61333333 54.61333333 54.61333333c14.19946667 0 25.66826667 11.4688 25.66826667 25.66826667s-11.4688 25.66826667-25.66826667 25.66826666z"
            fill="#333333" p-id="4079"></path>
          <path
            d="M509.26933333 240.57173333c-58.43626667 0-105.94986667-47.5136-105.94986666-105.94986666s47.5136-105.94986667 105.94986666-105.94986667 105.94986667 47.5136 105.94986667 105.94986667c0 14.19946667-11.4688 25.66826667-25.66826667 25.66826666s-25.66826667-11.4688-25.66826666-25.66826666c0-30.03733333-24.576-54.61333333-54.61333334-54.61333334s-54.61333333 24.576-54.61333333 54.61333334 24.576 54.61333333 54.61333333 54.61333333c14.19946667 0 25.66826667 11.4688 25.66826667 25.66826667s-11.4688 25.66826667-25.66826667 25.66826666zM781.24373333 430.08H466.1248c-14.19946667 0-25.66826667-11.4688-25.66826667-25.66826667s11.4688-25.66826667 25.66826667-25.66826666h315.11893333c14.19946667 0 25.66826667 11.4688 25.66826667 25.66826666s-11.4688 25.66826667-25.66826667 25.66826667zM651.264 542.58346667H466.1248c-14.19946667 0-25.66826667-11.4688-25.66826667-25.66826667s11.4688-25.66826667 25.66826667-25.66826667h185.1392c14.19946667 0 25.66826667 11.4688 25.66826667 25.66826667s-11.4688 25.66826667-25.66826667 25.66826667z"
            fill="#333333" p-id="4080"></path>
          <path
            d="M209.44213333 966.38293333c-12.01493333 0-22.39146667-8.192-25.12213333-19.6608l-21.2992-89.01973333c-0.54613333-2.18453333-0.54613333-3.82293333-0.54613333-6.00746667V154.8288c0-14.19946667 11.4688-25.66826667 25.66826666-25.66826667h42.05226667c14.19946667 0 25.66826667 11.4688 25.66826667 25.66826667v696.86613333c0 2.18453333 0 3.82293333-0.54613334 6.00746667l-21.2992 89.01973333c-2.73066667 11.4688-13.1072 19.6608-24.576 19.6608z"
            fill="#27C18F" p-id="4081"></path>
          <path
            d="M230.1952 154.8288v696.86613333l-21.2992 89.01973334-21.2992-89.01973334V154.8288h42.5984m0-50.7904h-42.05226667c-28.39893333 0-51.33653333 22.9376-51.33653333 51.33653333v696.86613334c0 3.82293333 0.54613333 8.192 1.6384 12.01493333l21.2992 89.01973333c5.46133333 22.9376 26.2144 39.3216 49.69813333 39.3216s44.2368-16.384 49.69813334-39.3216l21.2992-89.01973333c1.09226667-3.82293333 1.6384-7.64586667 1.6384-12.01493333V154.8288c-0.54613333-27.8528-23.48373333-50.7904-51.88266667-50.7904z"
            fill="#333333" p-id="4082"></path>
          <path
            d="M99.1232 454.10986667c-14.19946667 0-25.66826667-11.4688-25.66826667-25.66826667v-245.76c0-38.22933333 31.1296-69.35893333 69.35893334-69.35893333 14.19946667 0 25.66826667 11.4688 25.66826666 25.66826666s-11.4688 25.66826667-25.66826666 25.66826667c-10.37653333 0-18.56853333 8.192-18.56853334 18.56853333v245.76c0.54613333 13.65333333-10.92266667 25.12213333-25.12213333 25.12213334z"
            fill="#333333" p-id="4083"></path>
          <path
            d="M178.31253333 762.6752c-14.19946667 0-25.66826667-11.4688-25.66826666-25.66826667v-208.0768c0-14.19946667 11.4688-25.66826667 25.66826666-25.66826666h63.8976c14.19946667 0 25.66826667 11.4688 25.66826667 25.66826666v208.0768c0 14.19946667-11.4688 25.66826667-25.66826667 25.66826667H178.31253333z"
            fill="#FFBA40" p-id="4084"></path>
          <path
            d="M242.21013333 528.93013333v208.0768H178.31253333v-208.0768h63.8976m0-50.7904H178.31253333c-28.39893333 0-51.33653333 22.9376-51.33653333 51.33653334v208.0768c0 28.39893333 22.9376 51.33653333 51.33653333 51.33653333h63.8976c28.39893333 0 51.33653333-22.9376 51.33653334-51.33653333v-208.0768c0-28.39893333-22.9376-51.33653333-51.33653334-51.33653334z"
            fill="#333333" p-id="4085"></path>
        </svg>
      </div>
    </div>
    <div class="main">
      <el-row :gutter="10">
        <el-col :span="16">
          <div class="main_left">
            <ul>
              <li v-for="(item, index) in subjectList" :key="index">
                <el-card shadow="never">
                  <div class="clearfix">
                    <div class="fl" style="margin-right: 10px;margin-top: 25px;">
                      <svg t="1658296902087" v-if="item.submissionInfo === 0" class="icon" viewBox="0 0 1024 1024"
                        version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13040" width="15" height="15">
                        <path d="M0 0h1024v1024H0V0z" fill="#202425" opacity=".01" p-id="13041"></path>
                        <path
                          d="M955.733333 512c0 245.077333-198.656 443.733333-443.733333 443.733333S68.266667 757.077333 68.266667 512 266.922667 68.266667 512 68.266667s443.733333 198.656 443.733333 443.733333z"
                          fill="#11AA66" p-id="13042"></path>
                        <path
                          d="M512 102.4C285.7984 102.4 102.4 285.7984 102.4 512s183.3984 409.6 409.6 409.6 409.6-183.3984 409.6-409.6S738.2016 102.4 512 102.4zM34.133333 512C34.133333 248.081067 248.081067 34.133333 512 34.133333s477.866667 213.947733 477.866667 477.866667-213.947733 477.866667-477.866667 477.866667S34.133333 775.918933 34.133333 512z"
                          fill="#11AA66" p-id="13043"></path>
                        <path
                          d="M787.114667 339.285333a51.2 51.2 0 0 1 0 72.362667l-307.2 307.2a51.2 51.2 0 0 1-72.362667 0l-170.666667-170.666667a51.2 51.2 0 0 1 72.362667-72.362666L443.733333 610.235733l271.018667-271.018666a51.2 51.2 0 0 1 72.362667 0z"
                          fill="#FFFFFF" p-id="13044"></path>
                      </svg>

                      <svg t="1658296992015" v-if="item.submissionInfo === -1" class="icon" viewBox="0 0 1024 1024"
                        version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13965" width="15" height="15">
                        <path
                          d="M827.392 195.584q65.536 65.536 97.792 147.456t32.256 167.936-32.256 167.936-97.792 147.456-147.456 98.304-167.936 32.768-168.448-32.768-147.968-98.304-98.304-147.456-32.768-167.936 32.768-167.936 98.304-147.456 147.968-97.792 168.448-32.256 167.936 32.256 147.456 97.792zM720.896 715.776q21.504-21.504 18.944-49.152t-24.064-49.152l-107.52-107.52 107.52-107.52q21.504-21.504 24.064-49.152t-18.944-49.152-51.712-21.504-51.712 21.504l-107.52 106.496-104.448-104.448q-21.504-20.48-49.152-23.04t-49.152 17.92q-21.504 21.504-21.504 52.224t21.504 52.224l104.448 104.448-104.448 104.448q-21.504 21.504-21.504 51.712t21.504 51.712 49.152 18.944 49.152-24.064l104.448-104.448 107.52 107.52q21.504 21.504 51.712 21.504t51.712-21.504z"
                          p-id="13966" fill="#d81e06"></path>
                      </svg>

                      <div v-if="item.submissionInfo != -1 && item.submissionInfo != 0
          " style=" font-size: 14px;" class="el-icon-minus"></div>
                    </div>
                    <div class="fl" style="width:calc(100% - 30px);">
                      <div class="clearfix" style="padding-left:20px;">
                        <div class="fl" style="margin-right:20px;font-size: 18px;color:#333;cursor: pointer;"
                          @click="goDetails(item)">
                          {{ item.code }}
                        </div>
                        <div class="fl" style="margin-right:20px;font-size: 18px;color:#333; cursor: pointer;"
                          @click="goDetails(item)">
                          {{ item.title }}
                        </div>
                        <div class="fr">
                          <el-tag v-if="item.difficultyTitle != null ? true : false"
                            style="background:white;color:#4594d5;" size="mini" type="info">{{ item.difficultyTitle
                            }}</el-tag>

                          <el-tag v-for="(item_tag, index) of item.problemTagArr" :key="index"
                            style="margin-left:10px;background:white;color:green;" size="mini" type="info">
                            {{ item_tag.tagInfo.title }}
                          </el-tag>

                          <el-tag v-if="item.sourceTitle != null ? true : false"
                            style="margin-left:10px;background:white;color:#DCA550;" type="info" size="mini">{{
          item.sourceTitle }}</el-tag>
                        </div>
                        <!-- <div class="fr">
                        <div style="cursor:pointer;" @click="SubmitRecords(item)">记录</div>
                      </div> -->
                      </div>
                      <div class="clearfix" style="margin-top:10px;padding-left:20px;">
                        <div class="fl" style="margin-right:50px; color: #999999; font-size: 14px;">
                          通过率:

                          <span style="margin-left:10px;" v-if="item.acceptSubmissionNum === 0 &&
          item.totalSubmissionNum === 0
          ">0
                          </span>
                          <span style="margin-left:10px;" v-else>{{
          (
            (item.acceptSubmissionNum /
              item.totalSubmissionNum) *
            100
          ).toFixed(2) + "%"
        }}
                          </span>
                        </div>

                        <div class="fl" style="margin-right:50px; color: #999999; font-size: 14px;">
                          正确提交:
                          <span style="margin-left:10px;">{{
            item.acceptSubmissionNum
          }}</span>
                        </div>

                        <div class="fl" style="margin-right:50px; color: #999999; font-size: 14px;">
                          总提交:
                          <span v-if="item.share_submission === false">{{
          item.totalSubmissionNum
        }}</span>
                          <el-link v-else style="margin-left:10px;" type="info" @click="SubmitRecords(item)">{{
          item.totalSubmissionNum }}</el-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-card>
              </li>
            </ul>
            <div style="margin: 20px; text-align: right">
              <el-pagination background @current-change="handleCurrent" :current-page="page_no" :page-size="page_size"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="condition">
            <div class="Title">
              <svg t="1658296270940" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="9266" width="15" height="15">
                <path
                  d="M139.636364 0h744.727272a139.636364 139.636364 0 0 1 139.636364 139.636364v744.727272a139.636364 139.636364 0 0 1-139.636364 139.636364H139.636364a139.636364 139.636364 0 0 1-139.636364-139.636364V139.636364a139.636364 139.636364 0 0 1 139.636364-139.636364z m560.081454 558.855758c0-11.496727-3.909818-21.379879-11.946666-30.11491L452.654545 293.872485c-8.254061-8.285091-19.750788-15.406545-33.512727-21.379879-14.242909-5.973333-26.872242-8.73503-38.353454-8.73503h-136.843637c-11.481212 0-21.348848 4.359758-29.618424 12.644848-8.269576 8.269576-12.629333 18.152727-12.629333 29.63394v136.533333c0 11.481212 2.761697 24.576 8.719515 38.36897 5.973333 14.242909 12.629333 25.289697 21.364363 33.543757L466.897455 749.847273c8.269576 8.269576 18.137212 11.946667 29.618424 11.946666s21.348848-3.909818 30.083879-11.946666L687.771152 588.489697c7.586909-8.269576 11.946667-18.152727 11.946666-29.633939z m110.716121-30.471758L576.574061 293.85697c-8.22303-8.269576-19.642182-15.39103-33.357576-21.364364-14.149818-5.973333-26.701576-8.73503-38.120727-8.73503h-73.541819c11.419152 0 24.436364 2.761697 38.136243 8.73503 14.165333 5.973333 25.134545 12.629333 33.357576 21.364364l233.844363 234.52703c8.22303 8.73503 12.101818 18.618182 12.101818 30.099394s-3.878788 21.364364-12.101818 29.633939l-153.243151 154.59297c6.62497 6.671515 12.567273 11.481212 17.361454 14.708364 4.794182 3.211636 11.419152 4.344242 19.176728 4.344242 11.419152 0 21.255758-3.878788 29.928727-12.163879l160.31806-161.714424c8.22303-8.269576 11.869091-18.152727 11.869091-29.633939s-3.878788-20.898909-11.869091-29.866667zM338.97503 400.911515a40.649697 40.649697 0 0 1-29.944242 12.25697c-11.589818 0-21.566061-3.925333-29.913212-12.25697a40.494545 40.494545 0 0 1-12.288-29.882182c0-11.574303 3.940848-21.519515 12.288-29.866666 8.347152-8.331636 18.323394-12.25697 29.928727-12.25697 11.589818 0 21.566061 3.925333 29.928727 12.25697 8.347152 8.347152 12.055273 18.307879 12.055273 29.866666 0.698182 11.822545-3.723636 21.550545-12.055273 29.882182z"
                  fill="#1296db" p-id="9267"></path>
              </svg>
              按难度筛选
            </div>
            <div style="width:100%">
              <el-checkbox-group v-model="conditions">
                <el-checkbox v-for="item in conditionList" :label="item.id" :key="item.id" @change="changeConditions">
                  {{ item.title }}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="Knowledge" @click="close">
              <div class="Title">
                <svg t="1658296270940" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="9266" width="15" height="15">
                  <path
                    d="M139.636364 0h744.727272a139.636364 139.636364 0 0 1 139.636364 139.636364v744.727272a139.636364 139.636364 0 0 1-139.636364 139.636364H139.636364a139.636364 139.636364 0 0 1-139.636364-139.636364V139.636364a139.636364 139.636364 0 0 1 139.636364-139.636364z m560.081454 558.855758c0-11.496727-3.909818-21.379879-11.946666-30.11491L452.654545 293.872485c-8.254061-8.285091-19.750788-15.406545-33.512727-21.379879-14.242909-5.973333-26.872242-8.73503-38.353454-8.73503h-136.843637c-11.481212 0-21.348848 4.359758-29.618424 12.644848-8.269576 8.269576-12.629333 18.152727-12.629333 29.63394v136.533333c0 11.481212 2.761697 24.576 8.719515 38.36897 5.973333 14.242909 12.629333 25.289697 21.364363 33.543757L466.897455 749.847273c8.269576 8.269576 18.137212 11.946667 29.618424 11.946666s21.348848-3.909818 30.083879-11.946666L687.771152 588.489697c7.586909-8.269576 11.946667-18.152727 11.946666-29.633939z m110.716121-30.471758L576.574061 293.85697c-8.22303-8.269576-19.642182-15.39103-33.357576-21.364364-14.149818-5.973333-26.701576-8.73503-38.120727-8.73503h-73.541819c11.419152 0 24.436364 2.761697 38.136243 8.73503 14.165333 5.973333 25.134545 12.629333 33.357576 21.364364l233.844363 234.52703c8.22303 8.73503 12.101818 18.618182 12.101818 30.099394s-3.878788 21.364364-12.101818 29.633939l-153.243151 154.59297c6.62497 6.671515 12.567273 11.481212 17.361454 14.708364 4.794182 3.211636 11.419152 4.344242 19.176728 4.344242 11.419152 0 21.255758-3.878788 29.928727-12.163879l160.31806-161.714424c8.22303-8.269576 11.869091-18.152727 11.869091-29.633939s-3.878788-20.898909-11.869091-29.866667zM338.97503 400.911515a40.649697 40.649697 0 0 1-29.944242 12.25697c-11.589818 0-21.566061-3.925333-29.913212-12.25697a40.494545 40.494545 0 0 1-12.288-29.882182c0-11.574303 3.940848-21.519515 12.288-29.866666 8.347152-8.331636 18.323394-12.25697 29.928727-12.25697 11.589818 0 21.566061 3.925333 29.928727 12.25697 8.347152 8.347152 12.055273 18.307879 12.055273 29.866666 0.698182 11.822545-3.723636 21.550545-12.055273 29.882182z"
                    fill="green" p-id="9267"></path>
                </svg>
                知识点筛选
                <!-- <el-button type="danger" round @click="eliminate">清除</el-button> -->
              </div>

              <div style="padding:0 25px" @click.stop>
                <el-tag style="margin:5px" v-for="(tag, index) in select_lable_ids" :key="index" closable
                  @close="handleClose(tag)" size="mini">
                  {{ tag.label_title }}
                </el-tag>
              </div>
              <ul class="clearfix" style="position: relative; z-index: 9;font-size:14px;margin-left:25px;" @click.stop>
                <li v-for="(item, index) in KnowledgeList" :key="index">
                  <div @click="close">
                    <span @click.stop="listChange(item, index)">{{
          item.title
        }}</span>
                    <span @click.stop="listChange(item, index)" class="el-icon-caret-bottom"></span>
                  </div>
                  <el-card class="box-card" v-if="isCard == index">
                    <div slot="header" class="clearfix">
                      <el-checkbox :indeterminate="isIndeterminate" v-model="item.checkAll"
                        @change="handleCheckAllChange(item)">全选
                      </el-checkbox>
                      <!-- <span style="float: right; padding: 3px 0" type="text">{{item.total}}</span> -->
                    </div>
                    <div class="text">
                      <el-checkbox-group v-model="select_lables" class="block">
                        <el-checkbox v-for="(lable, index) in item.tags" v-model="lable.checked"
                          :label="lable.label_title" :key="index" @change="CheckValue($event, lable)"
                          style="display:block">
                          <div>
                            {{ lable.label_title }}
                          </div>
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </el-card>
                </li>
              </ul>
            </div>
            <div class="source">
              <div class="Title">
                <svg t="1658296270940" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="9266" width="15" height="15">
                  <path
                    d="M139.636364 0h744.727272a139.636364 139.636364 0 0 1 139.636364 139.636364v744.727272a139.636364 139.636364 0 0 1-139.636364 139.636364H139.636364a139.636364 139.636364 0 0 1-139.636364-139.636364V139.636364a139.636364 139.636364 0 0 1 139.636364-139.636364z m560.081454 558.855758c0-11.496727-3.909818-21.379879-11.946666-30.11491L452.654545 293.872485c-8.254061-8.285091-19.750788-15.406545-33.512727-21.379879-14.242909-5.973333-26.872242-8.73503-38.353454-8.73503h-136.843637c-11.481212 0-21.348848 4.359758-29.618424 12.644848-8.269576 8.269576-12.629333 18.152727-12.629333 29.63394v136.533333c0 11.481212 2.761697 24.576 8.719515 38.36897 5.973333 14.242909 12.629333 25.289697 21.364363 33.543757L466.897455 749.847273c8.269576 8.269576 18.137212 11.946667 29.618424 11.946666s21.348848-3.909818 30.083879-11.946666L687.771152 588.489697c7.586909-8.269576 11.946667-18.152727 11.946666-29.633939z m110.716121-30.471758L576.574061 293.85697c-8.22303-8.269576-19.642182-15.39103-33.357576-21.364364-14.149818-5.973333-26.701576-8.73503-38.120727-8.73503h-73.541819c11.419152 0 24.436364 2.761697 38.136243 8.73503 14.165333 5.973333 25.134545 12.629333 33.357576 21.364364l233.844363 234.52703c8.22303 8.73503 12.101818 18.618182 12.101818 30.099394s-3.878788 21.364364-12.101818 29.633939l-153.243151 154.59297c6.62497 6.671515 12.567273 11.481212 17.361454 14.708364 4.794182 3.211636 11.419152 4.344242 19.176728 4.344242 11.419152 0 21.255758-3.878788 29.928727-12.163879l160.31806-161.714424c8.22303-8.269576 11.869091-18.152727 11.869091-29.633939s-3.878788-20.898909-11.869091-29.866667zM338.97503 400.911515a40.649697 40.649697 0 0 1-29.944242 12.25697c-11.589818 0-21.566061-3.925333-29.913212-12.25697a40.494545 40.494545 0 0 1-12.288-29.882182c0-11.574303 3.940848-21.519515 12.288-29.866666 8.347152-8.331636 18.323394-12.25697 29.928727-12.25697 11.589818 0 21.566061 3.925333 29.928727 12.25697 8.347152 8.347152 12.055273 18.307879 12.055273 29.866666 0.698182 11.822545-3.723636 21.550545-12.055273 29.882182z"
                    fill="#E6A23C" p-id="9267"></path>
                </svg>
                按来源筛选
              </div>
              <div style="width:100%;position: relative; z-index: 0;">
                <el-checkbox-group v-model="source">
                  <el-checkbox v-for="item in sourceList" :label="item.id" :key="item.id" @change="changeSourceList">
                    {{ item.title }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>

            <el-button type="primary" style="width:100%;margin-top:20px" @click="random">随机选题</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="提交记录" :visible.sync="dialogVisible" width="60%" top="5vh">
      <el-table :data="tableData" stripe style="width: 100%" height="65vh"
        :header-cell-style="{ background: '#f5f7fa', color: '#909399' }">
        <el-table-column width="50" label="序号">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + (page_no1 - 1) * page_size1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="提交人"> </el-table-column>
        <el-table-column label="语言">

          <template slot-scope="scope">
            <span v-if="scope.row.language === 0">C</span>
            <span v-if="scope.row.language === 1">C++</span>
            <span v-if="scope.row.language === 2">Python3</span>
          </template>
        </el-table-column>
        <el-table-column label="耗时">

          <template slot-scope="scope">
            <span v-if="scope.row.time_cost === null">0ms</span>
            <span v-else>{{ scope.row.time_cost }}ms</span>
          </template>
        </el-table-column>
        <el-table-column label="内存">

          <template slot-scope="scope">
            <span>{{ scope.row.memory_cost / 1024 }}kb</span>
          </template>
        </el-table-column>

        <el-table-column prop="created_time" label="提交时间">
        </el-table-column>
        <el-table-column label="状态">

          <template slot-scope="scope">
            <span v-if="scope.row.result === -1">程序输出不正确</span>
            <span v-if="scope.row.result === 0">程序输出正确</span>
            <span v-if="scope.row.result === 1">超时</span>
            <span v-if="scope.row.result === 2">超时</span>
            <span v-if="scope.row.result === 3">内存超限</span>
            <span v-if="scope.row.result === 4">程序运行错误</span>
            <span v-if="scope.row.result === 5">系统错误</span>
            <span v-if="scope.row.result === -2">编译失败</span>
            <span v-if="scope.row.result === 6">等待测评</span>
            <span v-if="scope.row.result === 7">测评中</span>
            <span v-if="scope.row.result === 8">部分输出正确</span>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="得分"> </el-table-column>
      </el-table>
      <div style="margin: 20px; text-align: right">
        <el-pagination @current-change="handleCurrent1" :current-page="page_no1" :page-size="page_size1"
          layout="total, prev, pager, next, jumper" :total="total1">
        </el-pagination>
      </div>
    </el-dialog>
    <el-dialog title="刷题记录" :visible.sync="dialogVisible1" width="80%" top="5vh">
      <el-form :inline="true" :model="formInline" size="mini">
        <el-form-item label="题目编号">
          <el-input v-model="formInline.problemCode" placeholder="请输入题目编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="学员姓名">
          <el-input v-model="formInline.stuRealName" placeholder="请输入学员姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="学员账号">
          <el-input v-model="formInline.stuUserName" placeholder="请输入学员账号" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchStu">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData1" stripe style="width: 100%" height="55vh"
        :header-cell-style="{ background: '#f5f7fa', color: '#909399' }">
        <el-table-column width="50" label="序号">

          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + (page_no2 - 1) * page_size2 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="提交人"> </el-table-column>
        <el-table-column prop="problemCode" label="题目编号"> </el-table-column>

        <el-table-column prop="problemTitle" label="题目" show-overflow-tooltip> </el-table-column>

        <el-table-column label="语言">

          <template slot-scope="scope">
            <span v-if="scope.row.language === 0">C</span>
            <span v-if="scope.row.language === 1">C++</span>
            <span v-if="scope.row.language === 2">Python3</span>
          </template>
        </el-table-column>
        <el-table-column label="耗时">

          <template slot-scope="scope">
            <span v-if="scope.row.time_cost === null">0ms</span>
            <span v-else>{{ scope.row.time_cost }}ms</span>
          </template>
        </el-table-column>
        <el-table-column label="内存">

          <template slot-scope="scope">
            <span>{{ scope.row.memory_cost / 1024 }}kb</span>
          </template>
        </el-table-column>

        <el-table-column prop="created_time" label="提交时间" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="状态" show-overflow-tooltip>

          <template slot-scope="scope">
            <span v-if="scope.row.result === -1">程序输出不正确</span>
            <span v-if="scope.row.result === 0">程序输出正确</span>
            <span v-if="scope.row.result === 1">超时</span>
            <span v-if="scope.row.result === 2">超时</span>
            <span v-if="scope.row.result === 3">内存超限</span>
            <span v-if="scope.row.result === 4">程序运行错误</span>
            <span v-if="scope.row.result === 5">系统错误</span>
            <span v-if="scope.row.result === -2">编译失败</span>
            <span v-if="scope.row.result === 6">等待测评</span>
            <span v-if="scope.row.result === 7">测评中</span>
            <span v-if="scope.row.result === 8">部分输出正确</span>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="得分"> </el-table-column>
      </el-table>
      <div style="margin: 20px; text-align: right">
        <el-pagination @current-change="handleCurrent2" :current-page="page_no2" :page-size="page_size2"
          layout="total, prev, pager, next, jumper" :total="total2">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSchoolOjProblemList,
  getOjProblemSourceList,
  getOjProblemDifficultyList,
  getOjProblemTagGroupList,
  getProblemOjSubmissionList,
  ojTchGetStuSubmission,
  getGhatGptToken
} from "@/api/educational.js";

export default {
  data() {
    return {

      firstTime: true,
      formInline: {},
      page_no2: 1,
      page_size2: 10,
      total2: 1,
      tableData1: [],
      dialogVisible1: false,
      arrChangeList: [],
      arrId: [],
      detailData: [],
      tags: [],
      formAdd: {},
      problem_id: "",
      tableData: [],
      dialogVisible: false,
      page_no1: 1,
      page_size1: 20,
      total1: 20,
      tagList: [
        {
          id: 1,
          lable: "111",
        },
      ],
      tagIdArr1: "",
      tagIdArr: [],

      keyword: "",
      page_no: 1,
      page_size: 20,
      total: 20,
      //
      source: [],
      sourceList: [],
      //   subLists: [],
      checkAll: false,
      checkedsubLists: [],
      subLists: [],
      isIndeterminate: true,
      isCard: -1,
      //按知识点筛选
      KnowledgeList: {},
      //按难度筛选列表
      conditions: [],
      conditionList: [],
      form: {
        resource: "",
        resource1: "",
      },
      activeClass: 0,
      topList: [],
      subjectList: [],

      //测试知识点
      checkList: ["你好", "我好"],

      select_lables: [],
      select_lable_ids: [],
    };
  },
  watch: {
    arrId(val) {
      console.log(val, 1147);
      this.arrChangeList = val;
    },
    // $route: {
    //   handler() {
    //     const routes = this.$router.options.routes
    //     const route = this.$route.matched[0]
    //     console.log(routes, 123456888);
    //     console.log(route, 123456888);

    //     routes.map((item) => {
    //       console.log(item, 123456888);

    //     })
    //   },
    //   immediate: true
    // }

  },
  activated() {
    if (this.firstTime === false) {
      this.getSchoolOjProblemList();

    }

  },

  mounted() {
    console.log(sessionStorage.getItem('codeTxt'), 123456);
    if (this.firstTime === true) {
      this.getSchoolOjProblemList();

    }
    // this.getSchoolOjProblemList();
    this.getOjProblemSourceList();
    this.getOjProblemDifficultyList();
    this.getOjProblemTagGroupList();
    this.getGhatGptToken();

  },
  methods: {

    //动态获得GPT-TOKEN
    getGhatGptToken() {
      getGhatGptToken().then((res) => {
        console.log("动态获取GPT");
        console.log(res.chatGptKeyList);
        localStorage.setItem('gpt_token', res.chatGptKeyList[0].key);
      });
    },

    searchStu() {
      this.page_no2 = 1
      this.ojTchGetStuSubmission()
    },
    handleCurrent2(val) {
      this.page_no2 = val
      this.ojTchGetStuSubmission()
    },
    stuRecord() {
      this.dialogVisible1 = true
      this.ojTchGetStuSubmission()

    },

    ojTchGetStuSubmission() {
      ojTchGetStuSubmission({
        problemCode: this.formInline.problemCode,
        stuRealName: this.formInline.stuRealName,
        stuUserName: this.formInline.stuUserName,
        page_no: this.page_no2,
        page_size: this.page_size2
      }).then((res) => {
        console.log(res, 123456);
        this.tableData1 = res.ojSubmissionList
        this.total2 = res.total
      })
    },
    search() {
      this.page_no = 1;
      this.getSchoolOjProblemList();
    },

    SubmitRecords(item) {
      this.page_no1 = 1;
      this.problem_id = item.id;
      this.dialogVisible = true;
      this.getProblemOjSubmissionList();
    },
    getProblemOjSubmissionList() {
      getProblemOjSubmissionList({
        isAll: this.formAdd.isAll,
        problem_id: this.problem_id,
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log(res);
        this.tableData = res.submissionList;
        this.total1 = res.total;
      });
    },
    handleCurrent1(val) {
      this.page_no1 = val;
      this.getProblemOjSubmissionList();
    },
    myNew() {
      this.firstTime = false
      this.$router.push({
        name: "MyquestionBank",
      });
    },

    getOjProblemTagGroupList() {
      getOjProblemTagGroupList({}).then((res) => {
        var TagDatas = res.ojProblemTagGroupList;
        console.log("知识点数据1");
        console.log(res);
        var knowinfo = {};

        this.KnowledgeList = [];
        TagDatas.map((item) => {
          knowinfo = {
            title: item.title,
            tags: [],
            checkAll: false,
          };

          for (let i = 0; i < item.tagArrInfo.length; i++) {
            var tag = {};

            tag.label_title = item.tagArrInfo[i].title;
            tag.id = item.tagArrInfo[i].id;

            knowinfo.tags.push(tag);
          }

          this.KnowledgeList.push(knowinfo);
          console.log("知识点集合");
          console.log(this.KnowledgeList);
        });
      });
    },

    getOjProblemDifficultyList() {
      getOjProblemDifficultyList({}).then((res) => {
        console.log(res);
        this.conditionList = res.ojProblemDifficultyList;
      });
    },
    changeConditions() {
      this.page_no = 1;
      this.getSchoolOjProblemList();
    },
    getOjProblemSourceList() {
      getOjProblemSourceList({}).then((res) => {
        console.log(res);
        this.sourceList = res.ojProblemSourceList;
      });
    },
    changeSourceList(val) {
      this.page_no = 1;
      console.log(val);
      this.getSchoolOjProblemList();
    },

    //随机
    random() {
      this.firstTime = false

      let index = Math.floor(Math.random() * this.subjectList.length);
      this.$router.push({
        name: "questionBankDetails",
        query: {
          id: this.subjectList[index].id,
        },
      });
    },
    goDetails(item) {
      this.firstTime = false

      console.log(item, 11);
      this.$router.push({
        name: "questionBankDetails",
        query: {
          id: item.id,
          totalSubmissionNum: item.totalSubmissionNum,
          acceptSubmissionNum: item.acceptSubmissionNum,
          contest_id: item.contest_id,
          type1: "problem",
        },
      });
    },
    handleCurrent(val) {
      this.page_no = val;
      this.getSchoolOjProblemList();
    },

    checkIndex(index) {
      this.activeClass = index; // 把当前点击元素的index，赋值给activeClass
    },
    eliminate() {
      getSchoolOjProblemList({
        title_code: this.keyword,
        isPlatform: this.form.resource,
        difficultyIdArr: JSON.stringify(this.conditions),
        sourceIdArr: JSON.stringify(this.source),
        tagIdArr: JSON.stringify([]),
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res, 112);
        this.subjectList = res.ojProblemList;
        this.total = res.total;
      });
    },
    close() {
      this.isCard = -1;
    },
    listChange(item, index) {
      if (index == this.isCard) {
        this.isCard = -1;
      } else {
        this.isCard = index;
      }
      this.subLists = item.tagArrInfo;
    },
    handleCheckAllChange(item) {
      console.log("批量操作");
      console.log(item);
      console.log(this.checkAll);

      if (item.checkAll) {
        console.log("全选知识点");
        for (let i = 0; i < item.tags.length; i++) {
          this.select_lables.push(item.tags[i].label_title);
          this.select_lable_ids.push(item.tags[i]);
        }
        console.log("当前已选标签");
        console.log(this.select_lables);
        console.log(this.select_lable_ids);

        this.isIndeterminate = false;
      } else {
        console.log("取消全选");
        for (let i = 0; i < item.tags.length; i++) {
          for (let j = 0; j < this.select_lable_ids.length; j++) {
            if (item.tags[i].id == this.select_lable_ids[j].id) {
              this.select_lables.splice(j, 1);
              this.select_lable_ids.splice(j, 1);
            }
          }
        }
      }

      this.getSchoolOjProblemList();
    },

    CheckValue(e, lable) {
      console.log("值变化");
      console.log(lable);
      console.log(e);

      if (e) {
        this.select_lable_ids.push(lable);
      } else {
        this.isIndeterminate = true;
        for (let i = 0; i < this.select_lable_ids.length; i++) {
          if (lable.label_title == this.select_lable_ids[i].label_title) {
            this.select_lable_ids.splice(i, 1);
          }
        }
      }

      this.getSchoolOjProblemList();
    },

    handleClose(tag) {
      console.log("移除标签");
      console.log(tag);

      for (let i = 0; i < this.select_lables.length; i++) {
        if (this.select_lables[i] == tag.label_title) {
          this.select_lables.splice(i, 1);
          this.select_lable_ids.splice(i, 1);
        }
      }

      console.log("当前已选标签");
      console.log(this.select_lables);
      console.log(this.select_lable_ids);
      this.page_no = 1;
      this.getSchoolOjProblemList();
    },
    getSchoolOjProblemList() {
      var select_ids = [];
      this.select_lable_ids.map((item) => {
        select_ids.push(item.id);
      });

      getSchoolOjProblemList({
        title_code: this.keyword,
        isPlatform: this.form.resource,
        difficultyIdArr: JSON.stringify(this.conditions),
        sourceIdArr: JSON.stringify(this.source),
        tagIdArr: JSON.stringify(select_ids),
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res, 112);
        this.subjectList = res.ojProblemList;
        this.total = res.total;
      });
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.el-pagination.is-background .el-pager li {
  background-color: white;
}
</style>

<style scoped lang="scss">
.prepareLessons {
  margin: 10px;
  min-height: calc(100vh - 120px);
  //   background: #ccc;
  border-radius: 5px;
  overflow: hidden;
}

.top {
  padding: 20px;
  padding-bottom: 0px;
  font-size: 18px;
  font-weight: 300;
  background: #fff;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

/deep/ .el-dropdown-link {
  cursor: pointer;
  color: #333;
}

.line {
  height: 50px;
  width: 2px;
  background: #999;
  margin: 0 20px;
}

.top li {
  cursor: pointer;
  float: left;
  margin-right: 20px;
}

.active {
  color: #41b146;
}

.main {
  width: 100%;
  margin-top: 10px;
}

.main_left {
  width: 100%;
}

.main_left ul {
  width: 100%;
}

.main_left li {
  width: 100%;
  background: #fff;
  margin-top: 5px;
}

.main_left li:nth-of-type(1) {
  margin-top: 0;
}

.condition {
  width: 100%;
  border-radius: 5px;
  background: #fff;
  padding: 20px 15px;
}

.condition ::v-deep .el-checkbox {
  width: 50%;
  margin-right: 0px;
  margin-top: 10px;
}

.Title {
  font-size: 18px;
  font-weight: bold;
}

.Knowledge {
  margin-top: 20px;
}

.Knowledge li {
  float: left;
  width: 50%;
  cursor: pointer;
  margin-top: 20px;
}

.source {
  margin-top: 20px;
}

.topFrom ::v-deep .el-form-item {
  margin-bottom: 0px;
}

.box-card {
  position: absolute;
  z-index: 100;
}

/deep/.el-dialog {
  border-radius: 10px !important;
}
</style>
